import { render, staticRenderFns } from "./waterMaster04.vue?vue&type=template&id=5e1ba924"
import script from "./waterMaster04.vue?vue&type=script&lang=js"
export * from "./waterMaster04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e1ba924')) {
      api.createRecord('5e1ba924', component.options)
    } else {
      api.reload('5e1ba924', component.options)
    }
    module.hot.accept("./waterMaster04.vue?vue&type=template&id=5e1ba924", function () {
      api.rerender('5e1ba924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/water/mst/waterMaster04.vue"
export default component.exports